import LottieAnimation from '../vendor/LottieAnimation';
import ScrollNavbar from '../utils/ScrollNavbar';
import ShowNavSide from '../utils/ShowNavSide';

// Custom
ScrollNavbar.init();
ShowNavSide.init();

LottieAnimation.init();
